document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cfsw .pcs-img').forEach(function (t) {
    var down = false, moved = false, startX = 0, startScroll = 0;

    t.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = false;
      startX = e.pageX;
      startScroll = t.scrollLeft;
      t.classList.add('cfsw-grabbing');
    });

    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 3) moved = true;
      if (moved) {
        e.preventDefault();
        t.scrollLeft = startScroll - dx;
      }
    });

    window.addEventListener('mouseup', function () {
      down = false;
      t.classList.remove('cfsw-grabbing');
      if (moved) setTimeout(function () { moved = false; }, 0);
    });

    t.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    t.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });
});